<template>
    <div class="main-container">

        <!-- Navbar section -->
        <Navbar />

        <section class="hero-branding bg-cover col-lg-12 bg-img" :style="bgImg">
            <div class="container-fluid container-fluid--cp-150 mobile-px-0">
                <div class="hero-branding responsive-hero-branding">
                    <div class="hero-content py-5">
                        <h1 class="h1 main-title text-center text-md-left">{{ $t('printing3D.mainTitle') }}</h1>
                        <p class="h5 hero-content-subtitle mt-20 text-center text-md-left">{{ $t('printing3D.mainText') }}</p>
                        <div class="slider-button mt-30 text-center text-md-left">
                            <router-link :to="$t('links.contactUs')" class="ht-btn ht-btn-md">{{ $t('general.getQuoteBtn') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Preorder WJ51C -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area pb-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('printing3D.section6Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('printing3D.section6Text') }}</p>
                            <div class="tab-button wow move-up">
                                <router-link :to="$t('links.wj51c')" class="ht-btn ht-btn-md">{{ $t('general.moreInfoBtn') }}</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/wj51c-3d-printer.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" 
                         width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Jewelry Section -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area-background py-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('printing3D.section4Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('printing3D.section4Text') }}</p>
                            <ul class="requirements-list__items wow move-up">
                                <li>
                                    <strong>{{ $t('printing3D.section4bullet1Title') }}</strong>
                                    {{ $t('printing3D.section4bullet1Text') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/jewelry-preview.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" 
                         width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Prototype Section -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area py-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('printing3D.section2Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('printing3D.section2Text') }}</p>
                            <ul class="requirements-list__items wow move-up">
                                <li>
                                    <strong>{{ $t('printing3D.section2bullet1Title') }}</strong>
                                    {{ $t('printing3D.section2bullet1Text') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/prototype.jpg" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" 
                         width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Section Industrial -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area-background py-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('printing3D.section1Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('printing3D.section1Text') }}</p>
                            <ul class="requirements-list__items wow move-up">
                                <li>
                                    <strong>{{ $t('printing3D.section1bullet1Title') }}</strong>
                                    {{ $t('printing3D.section1bullet1Text') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/industrial.jpg" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" 
                         width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 3 -->
        <!-- <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area-background py-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('printing3D.section3Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('printing3D.section3Text') }}</p>
                            <ul class="requirements-list__items wow move-up">
                                <li>
                                    <strong>{{ $t('printing3D.section3bullet1Title') }}</strong>
                                    {{ $t('printing3D.section3bullet1Text') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/teeth.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" 
                         width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div> -->

        <div class="contact-form-section width-50 mobile-w-90 mx-auto py-5 mb-0">
			<div class="section-title text-left section-space--mb_60">
				<h3 class="font-weight--bold mb-15 wow move-up h3 my-0 main-title">{{ $t('pageSoumission.mainTitle') }}</h3>
				<p class="section-text_left wow move-up m-sm-0 m-md-0 mt-20 mw-100">{{ $t('pageSoumission.mainText') }}</p>
			</div>
			<ContactForm :boolEmbeded="false" :ctaText="$t('pageSoumission.callToAction')" />
		</div>

        <!-- Section Explore -->
        <div class="container-fluid container-fluid--cp-150 mobile-px-0 requirements-list-area-background">
            <div class="feature-icon-list-area">
                <div class="requirements-list-area  py-5">
                    <div class="row align-items-center mw-100 mx-auto">
                        <div class="col-sm-12 col-lg-12 d-flex justify-content-center">
                            <div class="w-100 requirements-list">
                                <p class="main-title mb-20 wow move-up">
                                    {{ $t('printing3D.section5Title') }}
                                </p>
                                <p class="requirements-list__text heading mb-40 wow move-up">
                                    {{ $t('printing3D.section5Text') }}
                                </p>

                                <!-- CTA cards -->
                                <div class="row justify-content-center text-center">
                                    <!-- Buyer -->
                                    <div class="col-12 col-md-4 mb-4">
                                        <div class="p-4 h-100 rounded-3 shadow-sm bg-white d-flex flex-column justify-content-between">
                                            <div>
                                                <h5 class="fw-bold mb-2">{{ $t('printing3D.section5bullet1Title') }}</h5>
                                                <p>{{ $t('printing3D.section5bullet1Text') }}</p>
                                            </div>
                                            <div class="mt-3">
                                                <router-link
                                                    :to="$t('links.buyer')" 
                                                    class="ht-btn ht-btn-md w-100"
                                                >
                                                    {{ $t('general.moreInfoBtn') }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Partner -->
                                    <div class="col-12 col-md-4 mb-4">
                                        <div class="p-4 h-100 rounded-3 shadow-sm bg-white d-flex flex-column justify-content-between">
                                            <div>
                                                <h5 class="fw-bold mb-2">{{ $t('printing3D.section5bullet2Title') }}</h5>
                                                <p>{{ $t('printing3D.section5bullet2Text') }}</p>
                                            </div>
                                            <div class="mt-3">
                                                <router-link
                                                    :to="$t('links.partner')"
                                                    class="ht-btn ht-btn-md w-100"
                                                >
                                                    {{ $t('general.moreInfoBtn') }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Talent / Expert -->
                                    <div class="col-12 col-md-4 mb-4">
                                        <div class="p-4 h-100 rounded-3 shadow-sm bg-white d-flex flex-column justify-content-between">
                                            <div>
                                                <h5 class="fw-bold mb-2">{{ $t('printing3D.section5bullet3Title') }}</h5>
                                                <p>{{ $t('printing3D.section5bullet3Text') }}</p>
                                            </div>
                                            <div class="mt-3">
                                                <router-link
                                                    :to="$t('links.talentExpert')"
                                                    class="ht-btn ht-btn-md w-100"
                                                >
                                                    {{ $t('general.moreInfoBtn') }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer section -->
        <FooterMain />
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import FooterMain from '../components/FooterMain.vue'
	import ContactForm from '../components/ContactForm.vue'
    
    export default {
        name: '3DPrinting',
        components: {
            Navbar,
            FooterMain,
            ContactForm
        },
		data(){
			return{
				testVar1 : process.env.VUE_APP_GTAG_UA
			}
		},
        metaInfo(){
            return {
                title: this.$i18n.t('tabTitle.printing3D'),
                meta: [
                    { "name": "description", "content":  this.$i18n.t('meta.description.printing3D') },
                    { "name": "theme-color", "content": "#007BFF;" }
                ]
            }
        },
        created(){
            if(typeof window.gtag !== 'undefined'){
                window.gtag('config', process.env.VUE_APP_GTAG_UA, {
                'page_title' : this.$i18n.t('tabTitle.printing3D'),
                'page_path': this.$i18n.t('links.printing3D')
                });
                window.gtag('config', process.env.VUE_APP_GTAG_G, {
                    'page_title' : this.$i18n.t('tabTitle.printing3D'),
                    'page_path': this.$i18n.t('links.printing3D')
                });
            }
            if(typeof window.fbq !== 'undefined'){
                window.fbq('track', 'PageView');
            }
        }
    }
</script>
